import makeStyles from 'e100-react-components/lib/styles/makeStyles';

import popoverRectangle from 'assests/popover-rectangle.svg';

import { IPropTypes as PopoverProps } from 'e100-react-components/lib/components/Popover';

const DECORATION_RECTANGLE_SIZE = {
  width: 29,
  height: 8
}

interface StyleProps {
  transformOriginVertical: Required<PopoverProps>['transformOrigin']['vertical']
}

export const useStyles = makeStyles(({
  spacing,
  shape
}) => ({
  popoverRoot: ({ transformOriginVertical }: StyleProps) => ({
    width: spacing(31.25),
    padding: spacing(1.5),
    ...transformOriginVertical === 'top' && {
      marginTop: spacing(2),
    },
    ...transformOriginVertical === 'bottom' && {
      marginTop: spacing(-2),
    },
    overflow: 'visible',
    '&:after': {
      content: "' '",
      width: DECORATION_RECTANGLE_SIZE.width,
      height: DECORATION_RECTANGLE_SIZE.height,
      background: `url(${popoverRectangle}) center center`,
      backgroundRepeat: 'no-repeat',
      position: 'absolute',
      left: '50%',
      
      ...transformOriginVertical === 'top' && {
        top: -DECORATION_RECTANGLE_SIZE.height,
        transform: 'translateX(-50%)',
      },
      ...transformOriginVertical === 'bottom' && {
        bottom: -DECORATION_RECTANGLE_SIZE.height + 1,
        transform: 'translateX(-50%) rotate(180deg)',
      }
    }
  }),
  dialogRoot: {
    inset: 'auto !important',
    bottom: '0 !important',
    width: '100%',
    height: 'auto'
  },
  contentRoot: {
    paddingLeft: spacing(2),
    paddingRight: spacing(2),
    borderTopColor: 'transparent'
  },
  titleRoot: {
    backgroundColor: 'transparent'
  },
  dialogPaper: {
    borderTopLeftRadius: shape.borderRadius,
    borderTopRightRadius: shape.borderRadius
  }
}));
